module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/email-c47e4f4c8fd059652adf6789d23a530c.svg";